import { create } from 'apisauce';

const api = create({
  baseURL: 'https://5ui894zxx2.execute-api.us-east-1.amazonaws.com/dev' //  'http://localhost:3000/dev' //
});

const setAuthorizationHeader = async (token) => {
    const VamosOQueToken = `${token.token}`;
    localStorage.setItem('VamosOQueToken', VamosOQueToken);
    // console.log(localStorage.getItem('VamosOQueToken'))
    api.setHeader('Authorization', localStorage.getItem('VamosOQueToken'))  
    return 'done';
};

// AUTH
export const login = async (values) => {
    return api.post('/auth/login', values)
      .then(async (res) => {
        setAuthorizationHeader(res.data);
        const user = await getMe();
        // console.log('user', user)
        return user;
      })
      .catch((err) => console.log('error', err));
};
  
export const registerUser = async (values) => {
    return api.post('/auth/register', values)
      .then(async (res) => {
        if(res.data !== 200){
          return res;
        }
        setAuthorizationHeader(res.data);
        const user = await getMe();
        // console.log('user', user)
        return user;
      })
      .catch((err) => console.log(err));
};

export const getMe = async () => {
    api.setHeader('Authorization', localStorage.getItem('VamosOQueToken'));
    return api.get('/auth/me')
      .then((res) => {
        return res;
      })
      .catch((err) => console.log(err));
};


// STORES
export const getStores = async () => {
    return api.get('/stores/get-stores')
      .then(async (res) => {
        // console.log('stores', res)
        return res;
      })
      .catch((err) => console.log(err));
};

export const getStoreById = async (id) => {
    api.setHeader('Authorization', localStorage.getItem('VamosOQueToken'));
    return api.get(`/stores/get-store/${id}`)
      .then(async (res) => {
        // console.log(`store ${id}: `, res)
        return res;
      })
      .catch((err) => console.log(err));
};

export const getStoreProductsById = async (id) => {
  return api.get(`/products/get-store-products/${id}`)
    .then(async (res) => {
      // console.log(`store ${id}: `, res)
      return res;
    })
    .catch((err) => console.log(err));
};

// PRODUCTS
export const getProductById = async (id) => {
  return api.get(`/products/get-product/${id}`)
    .then(async (res) => {
      // console.log(`product ${id}: `, res)
      return res;
    })
    .catch((err) => console.log(err));
};